import React from "react";
import { ArrowRight } from "lucide-react";
import loja from "../img/loja-oducal.png";

const Loja = () => {
  return (
    <section className="loja-section">
      <div className="loja-grid">
        {/* Lado de la Imagen */}
        <div className="loja-image-wrapper">
          <img src={loja} alt="Ciudad de Loja Ecuador" className="loja-img" />
          <div className="loja-badge">
          
          </div>
        </div>

        {/* Lado del Texto */}
        <div className="loja-content">
          <h2
            style={{
              color: "#c4923e",
              fontSize: "0.75rem",
              fontWeight: "bold",
              letterSpacing: "3px",
              textTransform: "uppercase",
              marginBottom: "1rem",
            }}
          >
            La Sede
          </h2>

          <h3
            className="font-serif"
            style={{
              fontSize: "3rem",
              color: "#1a2b56",

              marginBottom: "2rem",
            }}
          >
            Loja: ciudad universitaria y corazón cultural del Ecuador
          </h3>

          <p
            style={{
              color: "#4b5563",
              fontSize: "1rem",
              lineHeight: "1.3",
              marginBottom: "1rem",
            }}
          >
            Ubicada al sur del Ecuador, Loja es reconocida como un referente
            académico y cultural del país. Su identidad está profundamente
            marcada por la presencia de universidades que dinamizan la vida de
            la ciudad, generando conocimiento, innovación y una activa comunidad
            estudiantil que la posiciona como un verdadero ecosistema
            universitario.
          </p>

        <p
            style={{
              color: "#4b5563",
              fontSize: "1rem",
              lineHeight: "1.3",
              marginBottom: "1rem",
            }}
          >
            {" "}
            Al mismo tiempo, Loja es considerada el corazón cultural del
            Ecuador, cuna de importantes expresiones artísticas, musicales y
            literarias que forman parte de su legado y de su vida cotidiana.
            Esta combinación de tradición y pensamiento contemporáneo convierte
            a la ciudad en un espacio propicio para el diálogo, la reflexión y
            el intercambio de ideas.
          </p>

          <p
            style={{
              color: "#4b5563",
              fontSize: "1rem",
              lineHeight: "1.3",
              marginBottom: "1rem",
            }}
          >
            {" "}
            En este contexto, Loja, y la Universidad Técnica Particular de Loja,
            se enorgullecen en presentarse como escenario para acoger este
            encuentro, ofreciendo no solo su capacidad académica, sino también
            una experiencia cultural que inspira y enriquece a quienes la
            visitan.{" "}
          </p>

        <p
            style={{
              color: "#4b5563",
              fontSize: "1rem",
              lineHeight: "1.3",
              marginBottom: "1rem",
            }}
          >
            Además, durante el desarrollo del VIII Encuentro de la Red de
            Comunicación de ODUCAL, Loja se viste de fiesta y cultura con el
            desarrollo del X Festival Internacional de Artes Vivas, donde la
            ciudad se transforma en un gran escenario a cielo abierto y se
            convierte en un punto de encuentro cultural donde el teatro, la
            danza, la música, el circo y las artes escénicas del mundo se viven
            intensamente en calles, plazas y teatros; una experiencia memorable.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Loja;
